import { useState } from 'react';
import { LuHistory } from 'react-icons/lu';
import RecordPanel from '../RecordPanel';
import SecaoHistorico from './SecaoHistorico';
import type { EntidadeHistorico } from '../../services/HistoricoService';

/* Histórico de uma tela sem ficha (Metas edita na célula; Tarefas padrão é a
   empresa inteira): um botão no cabeçalho que abre o painel com todos os
   eventos daquele tipo de registro. Cada evento diz de qual registro é no
   detalhe ("Ana · Faturamento · 10/2026"). docs/propostas/historico.html, fase 5. */
const HistoricoDaTela = ({ entidade, titulo }: { entidade: EntidadeHistorico; titulo: string }) => {
    const [aberto, setAberto] = useState(false);
    return (
        <>
            <button type="button" className="lk-btn" onClick={() => setAberto(true)}>
                <LuHistory size={14} /> Histórico
            </button>
            {/* O título é a tela; a seção já diz "Histórico" — sem repetir a palavra. */}
            <RecordPanel open={aberto} onClose={() => setAberto(false)} title={titulo} subtitle="Histórico de alterações">
                {aberto && <SecaoHistorico entidade={entidade} fonte="tela" />}
            </RecordPanel>
        </>
    );
};

export default HistoricoDaTela;
